var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$hasPermission('MANAGE_SHARED_MODULES'))?_c('button',{staticClass:"button is-small share-button",class:_vm.buttonClass,attrs:{"disabled":_vm.isLoading},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }